<template>
	<layout-admin>
		<!--<h1>hallo user grid!</h1>-->

		<div class="container-fluid">
			<h1 class="my-2">{{ __("Current listed quantities (by user type)") }}</h1>
			<ul>
				<li>
					{{
						__(
							"Contains all advertisements currently existing on the platform, both visible and invisible"
						)
					}}
				</li>
				<li>{{ __("Deleted listings are not included") }}</li>
				<li>
					{{
						__(
							"Quantities grouped by article / type of listing / user type / visibility"
						)
					}}
				</li>
			</ul>
			<table class="table">
				<thead>
					<tr>
						<td>{{ __("Article") }}</td>
						<td>{{ __("Type of listing") }}</td>
						<td>{{ __("User type") }}</td>
						<td>{{ __("Visible?") }}</td>
						<td>{{ __("Tons current total") }}</td>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(row, idx) in stats" :key="idx">
						<td>{{ row.label }}</td>
						<td>{{ row.trade }}</td>
						<td>{{ row.data.company_type }}</td>
						<td>{{ row.visible }}</td>
						<td>{{ row.data.total_qty }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</layout-admin>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		stats: {
			type: Array,
			required: true,
		},
	},
};
</script>
